import React, { Component } from 'react';
import { APP_URL_API } from '../../setup/configs'
import AuthService from './AuthService';
import Modal from '../../ui/modal/Modal';
import axios from 'axios';

export default function withAuth(AuthComponent) {
    const Auth = new AuthService(APP_URL_API);
    return class AuthWrapped extends Component {
    	constructor() {
		    super();
		    this.state = {
		        user: null,
		        isLoading: true,
		        showModal: false,
		        intervalId1: null
		    }
		}
        componentWillMount() {
		    if (!Auth.loggedIn()) {
		        this.props.history.replace('/login')
		    }
		    else {
		        try {
		            const config = { 'Authorization': 'Bearer '+ Auth.getToken()};
			        const url = APP_URL_API + 'auth/user';

			        this.serverRequest =
			            axios
			                .get(url, {headers: config})
			                .then(function(response) {
			                    this.setState({
					                user: response.data.data,
					                isLoading: false
					            });
					            this.isUserAboutToBeLoggedOutTimer();
					            this.isUserStillLoggedInTimer();
			                }.bind(this))
		        }
		        catch(err){
		            Auth.logout()
		            this.props.history.replace('/login')
		        }
		    }
		}

		componentWillUnmount() {
		     clearInterval(this.state.intervalId1);
		}

		// Every 15 seconds, check if user is about to be logged out. If so, display modal
		// with a button that can be cliced to extend the user session
		isUserAboutToBeLoggedOutTimer() {
			const intervalId1 = setInterval(function() {
					if(Auth.isTokenAboutToExpire()) {
						this.setState({showModal: true})
					}
				}.bind(this), 15000);
			this.setState({intervalId1: intervalId1});
		}

		// Every 15 seconds, check if the user is still logged in. If not, redirect user to login page
		isUserStillLoggedInTimer() {
			const timer = setInterval(function() {
				if (!Auth.loggedIn()) {
		        	clearInterval(timer);
		        	this.props.history.replace('/login')
		    	}
		    }.bind(this), 15000);
		}

		// Refresh user session/token
		extendLoginSession() {
			this.setState({
				showModal: false
			});
			Auth.refreshToken();
		}

		render() {
		    if (this.state.user) {
		        return (
		            <span>
		            	<AuthComponent history={this.props.history} user={this.state.user} {...this.props} />
		            	<Modal visible={this.state.showModal}>
		            		<h4>Dit login er ved at udløbe</h4>
		            		<button type="button" className="button" onClick={() => this.extendLoginSession()}>Forlæng login</button>
		            	</Modal>
		            </span>
		        )
		    }
		    else {
		        return null
		    }
		}
    }
}


// WEBPACK FOOTER //
// ./src/modules/auth/withAuth.js